import {Navigate, Route} from "react-router-dom";
import {
    ListPermitExtensionsPage,
    ViewPermitExtensionDocumentsSubPage,
    ViewPermitExtensionPage,
    ViewPermitExtensionProcessSubPage,
    ViewPermitExtensionSummarySubPage,
} from "permitextension/container";
import {ViewDocumentPanel} from "base/file/components";
import {
    PermitExtensionFeesStep,
    PermitExtensionInvoiceStep,
    PermitExtensionReportStep,
    PermitExtensionSignatureStep,
    PermitExtensionTypesAndDatesStep,
} from "permitextension/presentational";

const permitExtensionRoutes = [
    <Route key="permit-extension-manage" path="extensions/list">
        <Route
            key="permit-extension-list"
            path=""
            element={<ListPermitExtensionsPage />}
        />
        <Route
            key="permit-extension-detail"
            path=":id"
            element={<ViewPermitExtensionPage />}
        >
            <Route
                key="permit-extension-summary"
                path="summary"
                element={<ViewPermitExtensionSummarySubPage />}
            />

            <Route
                key="permit-extension-process"
                path="application"
                element={<ViewPermitExtensionProcessSubPage />}
            >
                <Route
                    key="permit-extension-process-pendente_guias_e_datas"
                    path="pendente_guias_e_datas"
                    element={<PermitExtensionTypesAndDatesStep />}
                />

                <Route
                    key="permit-extension-process-report_m"
                    path="report_m"
                    element={<PermitExtensionReportStep />}
                />
                <Route
                    key="permit-extension-payment-process-payment_e"
                    path="payment_e"
                    element={<PermitExtensionFeesStep />}
                />
                <Route
                    key="permit-extension-payment-process-invoice_s"
                    path="invoice_s"
                    element={<PermitExtensionInvoiceStep />}
                />
                <Route
                    key="permit-extension-payment-process-signature_s"
                    path="signature_s"
                    element={<PermitExtensionSignatureStep />}
                />
            </Route>
            <Route
                key="permit-application-documents"
                path="documents/*"
                element={<ViewPermitExtensionDocumentsSubPage />}
            >
                <Route
                    key="permit-application-documents-view"
                    path="detail/*"
                    element={<ViewDocumentPanel />}
                />
            </Route>
            <Route index element={<Navigate to="summary" replace />} />
        </Route>
    </Route>,
];

export default permitExtensionRoutes;
